import { createContext, useContext, useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { CalendarCheck, BookOpenCheck, FileText, Home, ListChecks, LogOut, Package, ShoppingBag, Target, TrendingUp, Trophy, User } from "lucide-react";
import { Logo } from "../components/Logo";
import { portalApi } from "./portalApi";
import { openHomework } from "./portalApi";
import "../test/testTheme.css";

const AuthCtx = createContext(null);
export const usePortalAccount = () => useContext(AuthCtx);

export const PortalShell = ({ children }) => {
  const navigate = useNavigate();
  const [account, setAccount] = useState(null); // null = loading, false = logged out

  useEffect(() => {
    let cancelled = false;
    portalApi.get("/portal/auth/me")
      .then(({ data }) => { if (!cancelled) setAccount(data); })
      .catch(async () => {
        try {
          await portalApi.post("/portal/auth/refresh");
          const { data } = await portalApi.get("/portal/auth/me");
          if (!cancelled) setAccount(data);
        } catch { if (!cancelled) setAccount(false); }
      });
    return () => { cancelled = true; };
  }, []);

  const logout = async () => {
    await portalApi.post("/portal/auth/logout").catch(() => {});
    setAccount(false);
    navigate("/portal/auth");
  };

  if (account === null) {
    return <div className="tp-shell"><div className="tp-wrap"><div className="tp-hero"><p className="tp-muted" data-testid="portal-loading">Loading your account…</p></div></div></div>;
  }
  if (account === false) return <Navigate to="/portal/auth" replace />;

  return (
    <AuthCtx.Provider value={account}>
      <div className="tp-shell">
        <div className="tp-topbar"><div className="tp-topbar-inner">
          <Link className="tp-brand" to="/portal" data-testid="portal-brand"><Logo size={24} /><span>PRANJAL SIR <b>PHYSICS</b></span></Link>
          <nav className="portal-nav" data-testid="portal-nav">
            <Link to="/portal" data-testid="portal-nav-home"><Home size={15} /> Home</Link>
            <Link to="/portal/daily" data-testid="portal-nav-daily"><CalendarCheck size={15} /> Daily Q</Link>
            <Link to="/portal/quiz" data-testid="portal-nav-quiz"><ListChecks size={15} /> Quiz</Link>
            <a href="/homework" onClick={(e) => { e.preventDefault(); openHomework(); }} data-testid="portal-nav-homework"><BookOpenCheck size={15} /> Homework</a>
            <Link to="/portal/challenge" data-testid="portal-nav-challenge"><Trophy size={15} /> Challenge</Link>
            <Link to="/portal/tests" data-testid="portal-nav-tests"><FileText size={15} /> Tests</Link>
            <Link to="/portal/weakness" data-testid="portal-nav-weakness"><TrendingUp size={15} /> Weakness</Link>
            <Link to="/portal/report" data-testid="portal-nav-report"><Target size={15} /> Report</Link>
            <Link to="/portal/store" data-testid="portal-nav-store"><ShoppingBag size={15} /> Store</Link>
            <Link to="/portal/purchases" data-testid="portal-nav-purchases"><Package size={15} /> Purchases</Link>
            <Link to="/portal/profile" data-testid="portal-nav-profile"><User size={15} /> Profile</Link>
          </nav>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span className="portal-student" data-testid="portal-student-name">{account.name.split(" ")[0]} · {account.student_id}</span>
            <button className="tp-btn ghost small" onClick={logout} data-testid="portal-logout"><LogOut size={14} /> Logout</button>
          </div>
        </div></div>
        {children}
        <div className="tp-footer"><span>© 2026 Pranjal Sir Physics</span><span><a href="/">Main site</a> · <a href="/privacy">Privacy</a></span></div>
      </div>
    </AuthCtx.Provider>
  );
};
